import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import Chip, { LabelChipProps } from 'modules/core/components/Filter/base/Chip'
import ChipWithIcon from 'modules/core/components/Filter/base/ChipWithIcon'
import ClearValue from 'modules/core/components/Filter/base/ClearValue'
import Content from 'modules/core/components/Filter/base/Content'
import Provider from 'modules/core/components/Filter/base/Provider'
import useFilter from 'modules/core/components/Filter/base/useFilter'

import './index.styles.css'
type Option<T> = {
  label: string
  value: T
  component?: React.ReactNode
}

type Props<T> = LabelChipProps & {
  header?: React.ReactNode
  footer?: React.ReactNode
  options: readonly Option<T>[]
  value?: T
  selectedOption?: Option<T>
  onValueChange: (value: T) => void
  onToggle?: (open: boolean) => void
  defaultOpen?: boolean
  noFooter?: boolean
  fullWidth?: boolean
  onClose?: () => void
}

function Body<T>({ options }: { options: readonly Option<T>[] }) {
  const { value: filterValue, onValueChange } = useFilter()

  return (
    <Box flexDirection="column">
      {options.map(({ label, value, component }, index) => (
        <button key={index} className={'SingleChoice_option'} onClick={() => onValueChange(value)}>
          {component ?? (
            <Text.Normal size="300" color="grey800" ellipsis>
              {label}
            </Text.Normal>
          )}
          {filterValue === value && <Icon.Medium icon="check" color="viridian1200" />}
        </button>
      ))}
    </Box>
  )
}

function SingleChoice<T>({
  header,
  label,
  options,
  value,
  selectedOption,
  onValueChange,
  onToggle,
  defaultOpen,
  footer,
  icon,
  noFooter = false,
  fullWidth,
  onClose,
}: Props<T>) {
  const { value: selectedValue, label: activeLabel } = selectedOption || {
    value,
    label: options.find((option) => option.value === value)?.label,
  }
  const active = typeof selectedValue == 'boolean' ? true : selectedValue

  return (
    <Provider
      value={selectedValue}
      onValueChange={onValueChange}
      defaultOpen={!!defaultOpen}
      onClose={onClose}
    >
      {icon ? (
        <ChipWithIcon label={label} activeLabel={activeLabel} icon={icon} />
      ) : (
        <Chip.Toggler
          active={!!active}
          label={label}
          icon={icon}
          activeLabel={activeLabel}
          onToggle={onToggle}
          fullWidth={fullWidth}
        />
      )}
      <Content
        onClose={onClose}
        header={header}
        body={<Body options={options} />}
        footer={noFooter ? '' : footer || <ClearValue />}
      />
    </Provider>
  )
}

export default SingleChoice
